import {connect} from 'react-redux';
import Feedback, {FeedbackProps} from './Feedback';
import Action from '../../redux/Actions';
import Constants, {UserTypes, MobileViewingModes, QuizState} from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import UserModel from '../../types/UserModel';
import {RouteComponentProps, withRouter} from 'react-router';

const mapStateToProps = (state: ReduxState, ownProps: FeedbackContainerProps): Partial<FeedbackProps> => {
   return {
      history: ownProps.history,
      location: ownProps.location,
      match: ownProps.match,
      currentUser: state.currentUser || {} as UserModel,
      player: state.player,
      canvas: state.canvas,
      alternatePlaceholderText: ownProps.alternatePlaceholderText,
      addComment: ownProps.addComment,
      themeName: state.themeName || Constants.themeName.default,
      isUserSelfIdentified: ownProps.showCommentingAs && state.currentUser && state.currentUser.userType === UserTypes.selfIdentified,
      review: state.currentReview,
      reviewVersion: state.currentReviewVersion,
      goToLatest: ownProps.goToLatest,
      annotationExists: ownProps.annotationExists,
      mobileViewingMode: state.mobileViewingMode,
      showAnnotationsBar: ownProps.showAnnotationsBar && state.quizState === QuizState.closed
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<FeedbackProps> => {
   return {
      reviewFeedbackFocused: () => {
         dispatch(Action.reviewFeedbackFocused());
      },
      setAnnotationMode: annotationMode => {
         dispatch(Action.setAnnotationMode(annotationMode));
      },
      setMobileViewingMode: (mobileViewingMode: MobileViewingModes) => {
         dispatch(Action.setMobileViewingMode(mobileViewingMode));
      }
   };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Feedback));

export interface FeedbackContainerProps extends RouteComponentProps {
   alternatePlaceholderText?: string;
   hasFocus?: boolean;
   localStorageKey?: string;
   showAnnotationsBar: boolean;
   maxRows?: number;
   showCommentingAs?: boolean;
   annotationExists?: boolean;
   addComment(text: string): Promise<any>;
   onBlur?(): void;
   goToLatest?(): void;
}
